import type { EmbedInstance } from '@gr4vy/embed-react'
import type { Ref } from 'react'
import type {
  ApiError,
  ArgumentError,
  GravyTransactionFields,
  Option,
  Transaction,
  TransactionCancelled,
  TransactionCreated,
  TransactionFailed,
} from '~/features/payment/interfaces/gravy'

export interface IGr4vyEmbedComponent {
  ref?: Ref<EmbedInstance | null>
  gr4vyId: string
  environment: string
  token: string
  buyerId: string
  amount: number
  currency: string
  country: string
  intent?: string
  externalIdentifier: string
  metadata: { [key: string]: string }
  theme: { [key: string]: { [key: string]: string } }
  onEvent?: (name: string, data: any) => void // equal to gravy type
  onComplete?: (transaction: Transaction) => void // type Transaction not exported from gravy
  locale: string
}

export interface GravyProps {
  transactionFields: GravyTransactionFields
  isReadyToSubmit: boolean
  isPending: boolean
  onBack: () => void
  onGravyRequestSended: () => void
  onOptionsLoaded: (options: Option[]) => void
  onPaymentMethodSelected: (option: Option) => void
  onArgumentError: (err: ArgumentError) => void
  onFormUpdate: (data: boolean) => void
  onTransactionCreated: (data: TransactionCreated) => void
  onTransactionCancelled: (data: TransactionCancelled) => void
  onTransactionFailed: (data: TransactionFailed) => void
  onApiError: (err: ApiError) => void
}

export enum GravyEventsEnum {
  apiError = 'apiError',
  argumentError = 'argumentError',
  paymentMethodSelected = 'paymentMethodSelected',
  optionsLoaded = 'optionsLoaded',
  formUpdate = 'formUpdate',
  transactionCreated = 'transactionCreated',
  transactionCancelled = 'transactionCancelled',
  transactionFailed = 'transactionFailed',
}
